import React from 'react';

const SMSPrivPolicy = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-40 pb-12 px-4">
      <div className="max-w-4xl mx-auto">
        <header className="mb-8">
          <h1 className="text-4xl font-bold mb-4">PRIVACY POLICY</h1>
          <p className="text-lg text-gray-300">Effective Date: June 08, 2025</p>
        </header>

        <div className="space-y-8">
          <section>
            <p className="text-lg leading-relaxed">
              We value your privacy and make every effort to respect your wishes and personal information. 
              Please read this policy carefully to understand how we collect, use, and manage your phone numbers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">COLLECTION OF PHONE NUMBERS</h2>
            <p className="text-lg leading-relaxed">
              We collect your phone numbers only when you voluntarily provide them to us, for example, 
              during transactions, inquiries, or when you sign up for our promotional messages. You can 
              opt in to receive these SMS messages by providing your phone number during our onboarding process.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">USE OF PHONE NUMBERS FOR SMS</h2>
            <p className="text-lg leading-relaxed">
              Your phone numbers are primarily used to provide you with notifications when training is due, 
              and can be used to reply if you have questions about specific training materials. SMS messaging 
              charges may be applied by your carrier. We will only share your phone number with our SMS provider, 
              subject to their privacy policy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">OPTING OUT OF MARKETING MESSAGES</h2>
            <p className="text-lg leading-relaxed">
              If at any time you wish to stop receiving messages from us, you can opt out by texting STOP.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">PRIVACY OF PHONE NUMBERS</h2>
            <p className="text-lg leading-relaxed">
              Once you have opted out, we will not send you any more SMS messages, nor will we sell or 
              transfer your phone number to another party.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">CHANGES TO THIS POLICY</h2>
            <p className="text-lg leading-relaxed">
              We may periodically update this policy. We will notify you about significant changes in 
              the way we treat your information by placing a prominent notice on our site.
            </p>
          </section>

          <section>
            <p className="text-lg leading-relaxed">
              We thank you for your understanding and cooperation. If you have any questions or concerns 
              about this policy, please feel free to contact us via the form on our site.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SMSPrivPolicy;